import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {
  CorporateLoanApplication,
  CreateApplicationNoteFn,
  DigitalIdGetApplicationIndividualsFn,
  DownloadDocumentFromAzureFn,
  GetApplicationByIdFn,
  getApplicationStage,
  GetUserFn,
  isInternalUser,
  RefreshBankStatementFn,
  RemoveApplicationNoteByNoteIdFn,
  UpdateApplicationStageInSfFn,
  User,
  isAdminOrCreditUserOrSalesAM,
  isAdminOrCreditUser,
  GetContractStatusFn,
  GenerateApprovalNoticeFn,
  SendApprovalNoticeEmailFn,
  DeleteApprovalNoticeFileFn,
  AssetSettlementGetApplicationAssetFn,
  GetDisbursementByApplicationIdFn, SettleLoanFn, GetBsaLenderListFn, GetBsaExcludedLenderListFn, GetDscrCalculatorValueFn, UpdateDscrCalculatorValueFn, SaveBsaCalculatorFn, GetBsaCalculatorFn,
  GetActiveContractForApplicationFn,
  ContractDetails,
  DeclineContractFn,
  Disbursement,
  validateDisbursementData,
  ApiResponse,
  AzureStorageDocument,
  Application,
  GroupedDocument,
  formGroupedDocumentData,
  unclassifiedDocuments,
  groupStandardCondition,
  constants,
  applicationStageAllowSettleLoan,
  GetDscrCalculatorHistoryFn,
  RunCreditFlowFn,
  GetCreditWebServicesFn,
  GetApplicationCreditFlowResultFn,
  DownloadCreditorWatchReportFn,
  UpdateCreditStatusFn,
  GetCreditAuditLogFn,
  ApplicationSelectionObject,
  GetWebServiceReportFn,
  GetDuplicatedApplicationsFn,
  DuplicatedApplication,
  DeleteWebServicesFn,
  GetBasiqCustomerMappingFn,
  GetBasiqStatementDataForCompanyFn,
  RefreshBasiqConnectionsFn,
  GetBankStatementAndBasiqDataStatusFn,
  RequestMoreInformationFn,
  WithdrawApplicationFn,
  GetApplicationDscrFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  ResendContractFn,
  AggregatorAndOriginatorListValueGetFn,
  GetUserByAccessLevelFn,
  GetApplicationSettlementsOfficerFn,
  GetAmlOfficerCandidatesFn,
  NewWebService,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
  DigitalIdUpdateIndividualKycStatusFn,
  DigitalIdSyncIndividualKycFromFrankieOneFn,
} from '@portal-workspace/grow-shared-library';
import { GetBankStatementsAnalysisFn } from '@portal-workspace/grow-shared-library';
import { BreadcrumbComponentEvent, BreadcrumbComponent } from '../../breadcrumb-component/breadcrumb.component';
import { ApplicationSelectionType, applicationEntityDisplayName, } from '@portal-workspace/grow-shared-library';
import {
  ApproveApplicationDocumentFn,
  DeclineApplicationDocumentFn,
  DeleteApplicationDocumentFn,
  DigitalIdAddIndividualFn,
  DigitalIdSendVerificationSmsFn,
  DigitalIdUpdateApplicationIndividualDigitalIdMappingFn,
  SaveApplicationPartiesFn,
  DigitalIdVerifyOneApplicationIndividualFn,
  DownloadAllApplicationDocumentUrlFn,
  DownloadApplicationDocumentUrlFn,
  GetOriginatorByIdFn,
  ListApplicationDocumentFn,
  BusinessSearchFn,
   
  UpdateApplicationDocumentTagsFn,
  UpdateApplicationRequiredDocumentsFn,
  CreateDocumentWorklistFn,
  CompleteDocumentWorklistFn,
  GetNotesByApplicationIdFn,
  BusinessNumberSearchFn,
  UndoApplicationDocumentFn,
  AssetDocumentsComponent,
  PortalHotToastService,
  ApplicationDialogService,
  setupUntilDestroy,
  GetApplicationAuditLogsFn,
  applicationDefaultDocuments,
} from '@portal-workspace/grow-ui-library';
import { UpdateApplicationDocumentFn } from '../application-details.module';
import { GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent } from '@portal-workspace/grow-ui-library';
import { getUser } from '@portal-workspace/grow-ui-library';
import { CorporateLoansDocumentsComponent } from './corporate-loans-documents.component';
import { KycVerificationComponent } from '../kyc-verification.component';
import { confirmLeaveKycAmlTab } from '../kyc-unsaved-tab-guard';
import { CorporateLoansAppComponent } from './corporate-loans-app.component';
import {MatTabChangeEvent, MatTabsModule} from '@angular/material/tabs';
import { ApplicationStageIconComponent } from '../application-stage-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { BankComponent } from '../bank.component'
import {CorporateLoansPricingComponent} from "./corporate-loans-pricing.component";
import {CorporateLoansSettlementComponent} from "./corporate-loans-settlement.component";
import {UntilDestroy} from "@ngneat/until-destroy";
import {Subscription, combineLatest, of} from "rxjs";
import {switchMap, tap} from "rxjs/operators";
import {ApplicationTypeIconComponent} from '../../application-type-icon/application-type-icon.component';
import { CorporateLoansCreditComponent } from './corporate-loans-credit.component';
import { CreditReportComponent } from '../../credit-component/credit-report.component';
import { MessageBoxComponent } from '../../message-box/message-box.component';

export type CorporateTab = {selectionTypes: ApplicationSelectionType[], iconClass: string, name: string, index: number};

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'corporate-loans-application-details',
    templateUrl: './corporate-loans-application-details.component.html',
    styleUrls: ['./corporate-loans-application-details.component.scss'],
    standalone: true,
    imports: [
    FlexModule,
    BreadcrumbComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    ApplicationStageIconComponent,
    MatTabsModule,
    CorporateLoansAppComponent,
    KycVerificationComponent,
    CorporateLoansDocumentsComponent,
    BankComponent,
    AssetDocumentsComponent,
    CorporateLoansPricingComponent,
    ApplicationTypeIconComponent,
    CorporateLoansSettlementComponent,
    CorporateLoansCreditComponent,
    CreditReportComponent,
    MessageBoxComponent,
]
})
export class CorporateLoansApplicationDetailsComponent {

  tabs: CorporateTab[] = [];

  isInternalUser = isInternalUser;
  formGroupedDocumentData = formGroupedDocumentData;
  unclassifiedDocuments = unclassifiedDocuments;
  groupStandardCondition = groupStandardCondition;
  applicationStageAllowSettleLoan = applicationStageAllowSettleLoan;
  // possible selections that can be access directly through URL
  possibleSelections: ApplicationSelectionType[] = ['app', 'bank-statement', 'kyc-aml', 'documents', 'asset', 'pricing', 'credit-report'];

  subscriptions: Subscription[] = [];
  loggedInUser: User | null = getUser();

  @Input({required: true}) getOriginatorByIdFn!: GetOriginatorByIdFn;
  @Input({required: true}) addIndividualFn!: DigitalIdAddIndividualFn;
  @Input({required: true}) verifyOneApplicationIndividualFn!: DigitalIdVerifyOneApplicationIndividualFn;
  @Input({required: true}) sendVerificationSmsFn!: DigitalIdSendVerificationSmsFn;
  @Input({required: true}) getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  @Input({required: true}) saveApplicationPartiesFn!: SaveApplicationPartiesFn;
  @Input({required: true}) businessSearchFn!: BusinessSearchFn;
  @Input({required: true}) updateApplicationIndividualDigitalIdMappingFn!: DigitalIdUpdateApplicationIndividualDigitalIdMappingFn;
  @Input({required: true}) listApplicationDocumentFn!: ListApplicationDocumentFn;
  @Input({required: true}) downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  @Input({required: true}) approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  @Input({required: true}) declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  @Input({required: true}) deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  @Input({required: true}) downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  @Input({required: true}) updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  @Input({required: true}) updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
   
  @Input({required: true}) createDocumentWorklistFn!: CreateDocumentWorklistFn;
  @Input({required: true}) completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) getBankStatementsAnalysisFn!: GetBankStatementsAnalysisFn;
  @Input({required: true}) undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) bankStatementsUrl!: string;
  @Input({required: true}) application!: CorporateLoanApplication;

  @Input({required: true}) getContractStatusFn!: GetContractStatusFn;
  @Input({required: true}) businessNumberSearchFn!: BusinessNumberSearchFn;
  @Input({required: true}) refreshBankStatementFn!: RefreshBankStatementFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) downloadDocumentFromAzureFn!: DownloadDocumentFromAzureFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  @Input({required: true}) sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  @Input({required: true}) deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  @Input({required: true}) updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  @Input({required: true}) getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  @Input({required: true}) getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  @Input({required: true}) settleLoanFn!: SettleLoanFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getActiveContractForApplicationFn!: GetActiveContractForApplicationFn;
  @Input({required: true}) declineContractFn!: DeclineContractFn;
  @Input({required: true}) getWebServiceReportFn!: GetWebServiceReportFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;

  breadcrumbTrails: string[] = ['Applications'];
  activeContract: ContractDetails | null = null;

  @Input({required: true}) onBreadcrumbEventsFn: (evt: BreadcrumbComponentEvent) => void = (evt) => { };
  @Input({required: true}) allowContractGeneration!: boolean;

  currentSection: ApplicationSelectionType = 'app';
  currentSectionIndex: number = 0;
  getApplicationStage = getApplicationStage;

  @Input({required: true}) uploadApplicationDocumentFn!: UpdateApplicationDocumentFn;
  @Input({required: true}) getUsersInCompanyFn!: GetUsersByOriginatorBusinessIdFunc;
  @Input({required: false}) initialSelection: ApplicationSelectionType | null = null;
  @Input({required: true}) getBsaLenderListFn!: GetBsaLenderListFn;
  @Input({required: true}) getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  @Input({required: true}) getDscrCalculatorValueFn!: GetDscrCalculatorValueFn;
  @Input({required: true}) updateDscrCalculatorValueFn!: UpdateDscrCalculatorValueFn;
  @Input({required: true}) saveBsaCalculatorFn!: SaveBsaCalculatorFn;
  @Input({required: true}) getBsaCalculatorFn!: GetBsaCalculatorFn;
  @Input({required: true}) getDscrCalculatorHistoryFn!: GetDscrCalculatorHistoryFn;
  @Input({required: true}) getBankStatementAndBasiqDataStatusFn!: GetBankStatementAndBasiqDataStatusFn;
  @Input({required: true}) getBasiqCustomerMappingByAbnFn!: GetBasiqCustomerMappingFn;
  @Input({required: true}) getBasiqStatementDataForCompanyFn!: GetBasiqStatementDataForCompanyFn;
  @Input({required: true}) refreshBasiqConnectionsFn!: RefreshBasiqConnectionsFn;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) withdrawApplicationFn!: WithdrawApplicationFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) resendContractFn!: ResendContractFn;
  @Input({required: true}) getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;
  @Input({required: true}) getUserByAccessLevelFn!: GetUserByAccessLevelFn;
  @Input({required: true}) getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  @Input() getAmlOfficerCandidatesFn?: GetAmlOfficerCandidatesFn;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Input({required: true}) updateIndividualKycStatusFn!: DigitalIdUpdateIndividualKycStatusFn;
  @Input() syncIndividualKycFromFrankieOneFn?: DigitalIdSyncIndividualKycFromFrankieOneFn;

  @Output() navigateToApplications = new EventEmitter();
  @Output() selectionEvent: EventEmitter<ApplicationSelectionObject> = new EventEmitter<ApplicationSelectionObject>();
  @Output() events = new EventEmitter<UserSelectionComponentEvent & {type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer'}>();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  isAdminOrCreditUser = false;
  isAdminOrCreditUserOrSalesAM = false;

  @ViewChild(KycVerificationComponent) kycVerification?: KycVerificationComponent;

  constructor(
    private toastService: PortalHotToastService,
    private dialogService: ApplicationDialogService,
  ){}


  initTabs() {
    this.tabs = [];
    this.tabs.push({selectionTypes: ['app'], iconClass: 'mdi-view-grid-outline', name: 'APPLICATION', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['bank-statement'], iconClass: 'mdi-bank-outline', name: 'BANK STATEMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['kyc-aml'], iconClass: 'mdi-check-decagram-outline', name: 'CUSTOMER DETAILS(KYC/AML)', index:(this.tabs.length)});
    if (isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['credit', 'credit-report'], iconClass: 'mdi-calculator', name: 'CREDIT', index: (this.tabs.length)});
    }
    this.tabs.push({selectionTypes: ['documents'], iconClass: 'mdi-folder-outline', name: 'DOCUMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['asset'], iconClass: 'mdi-handshake-outline', name: 'CONTRACT', index: (this.tabs.length)});
    if (isAdminOrCreditUserOrSalesAM(this.loggedInUser) || isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['pricing'], iconClass: 'mdi-currency-usd', name: 'PRICING', index: (this.tabs.length)});
    }
  }

  hasUnsavedKycChanges(): boolean {
    return this.currentSection === 'kyc-aml' && !!this.kycVerification?.hasUnsavedChanges();
  }

  unsavedKycChangeLabels(): string[] {
    return this.kycVerification?.unsavedChangeLabels() ?? [];
  }

  async onSelectedTabChange(event: MatTabChangeEvent) {
    const previousSection = this.currentSection;
    const tabFound = this.tabs.find(t => t.index == event.index);
    const selection = tabFound ? tabFound.selectionTypes[0] : 'app' /* default selection if not found */ ;
    const canLeave = await confirmLeaveKycAmlTab({
      previousSection,
      nextSection: selection,
      kycVerification: this.kycVerification,
      dialogService: this.dialogService,
      revertToKycTab: () => {
        const kycTab = this.tabs.find(t => t.selectionTypes.includes('kyc-aml'));
        if (kycTab) {
          this.currentSectionIndex = kycTab.index;
        }
      },
    });
    if (!canLeave) {
      return;
    }
    this.currentSection = selection;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  ngOnInit() {
    setupUntilDestroy(this);
    this.isAdminOrCreditUser = isAdminOrCreditUser(this.loggedInUser);
    this.isAdminOrCreditUserOrSalesAM = isAdminOrCreditUserOrSalesAM(this.loggedInUser);
    this.initTabs();
    const routeTab = this.initialSelection;
    if (routeTab && this.possibleSelections.includes(routeTab)) {
      const _tab = this.tabs.find(tab => tab.selectionTypes.includes(routeTab));
      if (_tab) {
        this.currentSection = routeTab;
        this.currentSectionIndex = _tab.index;
      }
    }
    const entityName = applicationEntityDisplayName(this.application);
    if (entityName) {
      this.breadcrumbTrails.push(entityName);
    }

    this.getActiveContract(); //show signer button on page load event
  }

  onViewReport(element: NewWebService) {
    this.currentSection = 'credit-report';
    console.log(this.currentSection)
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: String(element.id),
    });
  }

  onLeaveReport(event: void) {
    this.currentSection = 'credit';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  getActiveContract() {
    this.subscriptions.push(
      this.getActiveContractForApplicationFn(this.application.ApplicationId)
        .subscribe((r: ContractDetails | null) => {
          this.activeContract = r;
        })
    )
  }

  openContractStatusDialog() {
    this.subscriptions.push(
      this.dialogService.openContractStatusDialog({
        getContractStatusFn: this.getContractStatusFn,
        applicationId: this.application.ApplicationId,
        declineContractFn: this.declineContractFn,
        envelopeId: this.activeContract?.envelopeId ?? "",
        resendContractFn: this.resendContractFn,
      }).afterClosed().subscribe(() => {
        this.getActiveContract();
      })
    )
  }

  doSendDisbursementToSf() {
    this.subscriptions.push(
      this.getDisbursementByApplicationIdFn(this.application.ApplicationId).pipe(
        switchMap((disbursements: Disbursement[]) => {
          // validate disbursements
          if (!validateDisbursementData(disbursements)) {
            return of({
              status: false,
              message: "Please make sure you enter payment details for all disbursements."
            })
          }
          return this.settleLoanFn({
            assets: [],
            disbursements: disbursements,
            salesforceId: this.application.AppInfoSalesforceID ?? ""
          })
        }),
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response?.status) {
          this.dialogService.successDialog({
            message: "Success",
            subMessage: "Asset and disbursement details sent to Salesforce",
          }).afterClosed().subscribe()
        } else {
          this.dialogService.openAlertDialog({
            message: "Error",
            subMessage: response.message,
          }).afterClosed().subscribe()
        }
      })
    )
  }

  onSettleLoan(){
    if (isInternalUser(this.loggedInUser)) {
      this.dialogService.openSettleLoanDialog()
        .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.doSendDisbursementToSf();
          }
        })
      ).subscribe()
    } else {
      // check documents first
      this.subscriptions.push(
        combineLatest([
          this.listApplicationDocumentFn(this.application.ApplicationId),
          this.getApplicationByIdFn(this.application.ApplicationId)
        ]).pipe(
          this.toastService.spinnerObservable()
        ).subscribe(([r, app]: [AzureStorageDocument[], Application]) => {
          if (r) {
            let docs: GroupedDocument[] = this.formGroupedDocumentData(r,
              app?.DocumentTypes?.length ? app?.DocumentTypes
              : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
              '',
            );
            docs = this.groupStandardCondition(docs, this.application);
            docs = this.displayRequiredDocumentsOnly(docs);
            const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
            const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
            const standardConditionDocs = docs.filter(d => d?.standardCondition);
            const pendingGroups = [
              ...otherDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
              ...nonStandardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
              ...standardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending')
            ];
            if (pendingGroups.length) {
              // do not allow settle loan
              this.dialogService.openAlertDialog({
                message: 'Error',
                subMessage: 'You cannot settle loan as you still have pending documents',
              }).afterClosed().subscribe();
            } else {
              this.doUpdateApplicationStage();
            }
          }
        })
      )
    }
  }

  private displayRequiredDocumentsOnly(docs: GroupedDocument[]) {
    return docs.filter(group => {
      if (
        group.value === constants.documentTypes.internalDocuments.value ||
        group.required || group.docs?.length
      ) {
        return true;
      }
      return false;
    })
  }


  doUpdateApplicationStage() {
    this.subscriptions.push(
      this.updateApplicationStageFn({
        salesforceId: this.application.AppInfoSalesforceID ?? "",
        stageName: 'QA'
      }).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response.status) {
          this.dialogService.successDialog({
            message: 'Success',
            subMessage: "Application sent to QA queue",
          }).afterClosed().subscribe();
        } else {
          this.dialogService.openAlertDialog({
            message: 'Error',
            subMessage: response.message,
          }).afterClosed().subscribe();
        }
      })
    )
  }

  onBreadcurmbEvents($event: BreadcrumbComponentEvent) {
    this.onBreadcrumbEventsFn($event);
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
